// `/`: operators land on the console, members with one company on that company, members with
// several pick one (spec 13 §Screens 1).
import { Card, CardDescription, CardHeader, CardTitle } from "@companyos/ui";
import { createRoute, Link, redirect } from "@tanstack/react-router";
import { companiesOf, isOperator } from "../features/company";
import { useSession } from "../features/use-feature";
import { PageHeader } from "../pages/status-pages";
import { PlainShell } from "../shell/app-shell";
import { authedRoute } from "./_authed";

export const indexRoute = createRoute({
  getParentRoute: () => authedRoute,
  path: "/",
  beforeLoad: ({ context }) => {
    if (isOperator(context.me)) throw redirect({ to: "/operator" });
    const companies = companiesOf(context.me);
    const only = companies.length === 1 ? companies[0] : undefined;
    if (only) throw redirect({ to: "/c/$slug", params: { slug: only.slug } });
  },
  component: CompanyPicker,
});

function CompanyPicker() {
  const { api } = indexRoute.useRouteContext();
  const { me } = useSession();
  const companies = companiesOf(me);
  return (
    <PlainShell me={me} api={api} current={companies[0]?.slug ?? null}>
      <PageHeader title="Your companies" description="Pick a company to open." />
      {companies.length === 0 ? (
        <p className="text-sm text-muted-foreground">
          You are not a member of any company yet. Ask the company owner for an invite.
        </p>
      ) : (
        <ul className="grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
          {companies.map((c) => (
            <li key={c.id}>
              <Link
                to="/c/$slug"
                params={{ slug: c.slug }}
                className="block rounded-xl outline-none focus-visible:ring-3 focus-visible:ring-ring"
              >
                <Card className="transition-colors hover:bg-accent">
                  <CardHeader>
                    <CardTitle>{c.name}</CardTitle>
                    <CardDescription>{c.roles.join(", ").replaceAll("_", " ")}</CardDescription>
                  </CardHeader>
                </Card>
              </Link>
            </li>
          ))}
        </ul>
      )}
    </PlainShell>
  );
}
